'use strict';

export {
    VOYADO_EVENT_MONITOR_CART,
    VOYADO_EVENT_MONITOR_EMPTY_CART,
    VOYADO_EVENT_TRACK_PRODUCT_IMPRESSION,
    VOYADO_SCRIPT_LOADED,
    VOYADO_INITIALIZE
} from './analytics/voyado/eventNames';
